var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-tabs',[_vm._l((_vm.menus),function(item,index){return [(_vm.hasPermission(item.permission))?_c('v-tab',{key:index,attrs:{"to":{ name: item.route }}},[_vm._v(" "+_vm._s(item.label)+" ")]):_vm._e()]})],2),_c('router-view',{attrs:{"height":_vm.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }